/* eslint-disable react/no-danger */
import { Box } from "@mui/material";

export const IconApproved = () => {
  const svgMarkup = `
<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
  <polyline points="4.872 8.711 7.975 11.814 9.352 10.344 10.73 8.873 15.322 3.971" fill="none" stroke="#28a745" strokewidth="3" style="stroke-miterlimit: 16.11; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px; transform-box: fill-box; transform-origin: 50% 50%;"></polyline>
</svg>
  `;

  return <Box dangerouslySetInnerHTML={{ __html: svgMarkup }} sx={{ width: 18, height: 18, lineHeight: "18px" }} />;
};
